var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"diagram"},[_c('div',{ref:"diagram",staticClass:"scroll",style:({ height: _vm.height + 'px', width: _vm.width + 'px' })}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOverview),expression:"isOverview"}],ref:"overview",staticClass:"overview"})])
}
var staticRenderFns = []

export { render, staticRenderFns }